<template>
  <b-container>
    <b-row class="justify-center py-5">
      <div class="col-12">
        <h1 class="display-4 align-center text-center">
          Order History
        </h1>
      </div>
    </b-row>
    <div v-if="!loading">
      <b-row v-if="orders.length > 0" class="justify-content-center pb-4">
        <b-col cols="12" sm="10">
          <b-list-group>
            <order
              v-for="(order, index) in orders"
              :key="index"
              :index="index"
              :order="order"
              @reorder="applyReorderItems"
            />
          </b-list-group>
        </b-col>
      </b-row>
      <b-container v-else>
        <b-row align-h="center" class="text-center pt-3">
          <p><b>Hey!</b> You haven't placed any orders yet.</p>
        </b-row>
        <b-row align-h="center" class="mt-3">
          <b-button class="btn-cta" to="/">
            Shop!
          </b-button>
        </b-row>
      </b-container>
      <b-row v-if="orders.length > 0" class="justify-content-center">
        <b-pagination
          v-model="currentPage"
          :per-page="itemsPerPage"
          :total-rows="totalOrders"
          pills
        />
      </b-row>
    </div>
    <b-row v-if="loading" align-h="center">
      <SmallSpinner :size="50" centered />
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { configuration } from '~/configuration';
import { axios } from '^/axios';
import { debounce } from 'lodash';
import Order from '@/order-history/Order.vue';
import SmallSpinner from '@/common/SmallSpinner.vue';

export default {
  name: 'OrderHistory',
  components: {
    SmallSpinner,
    Order,
  },
  data() {
    return {
      orders: [],
      currentPage: 1,
      totalOrders: 0,
      itemsPerPage: 5,
      loading: true,
      order: {},
      configuration,
    };
  },
  computed: {
    ...mapGetters(['region', 'regionId', 'vendor']),
  },
  created() {
    this.getOrderHistory();
  },
  methods: {
    getOrderHistory: debounce(async function () {
      let url = 'user/orders';
      this.loading = true;
      let response = await axios.get(url, {
        params: {
          page: this.currentPage,
          per_page: this.itemsPerPage,
          region_id: this.regionId,
          vendor_uuid: this.vendor.uuid,
        },
      });
      this.orders = response.data;
      this.totalOrders = response.meta.total;
      this.loading = false;
    }, 500),
    applyReorderItems(order) {
      this.order = order;
      this.$store.commit('clearCart');
      this.order.products.forEach(async (productWrapper) => {
        let product = productWrapper.product;
        product.quantityOrdered = productWrapper.quantity;
        product.orderedWeight = productWrapper.order_weight;
        product.weight = productWrapper.weight;

        product.modifiers = await axios.get(
          `/product/${product.uuid}/modifiers`
        );

        product.modifiers.forEach((modifier) => {
          modifier.items.forEach((item) => {
            let found = productWrapper.modifier_items.find(
              (x) => x.uuid === item.uuid
            );
            if (found) {
              this.$set(item, 'item_quantity', found.item_quantity);
            } else {
              this.$delete(item, 'item_quantity'); // Remove unselected modifiers
            }
          });
        });

        // Clone product before adding to cart to prevent reference issues
        const productCopy = JSON.parse(JSON.stringify(product));
        this.$store.commit('addProductToCart', productCopy);
      });
      this.$router.push('/cart');
    },
  },
  watch: {
    currentPage() {
      this.getOrderHistory();
    },
  },
};
</script>

<style scoped>
>>> .page-item.active .page-link {
  background-color: #3e3e3e !important;
}

>>> .page-link {
  color: #fff !important;
  background-color: #000 !important;
  border-color: #000 !important;
}
</style>
<style lang="scss" scoped>
@import '../../styles/variables.module.scss';
@include buttons;
</style>
